import { motion } from 'framer-motion';
import { Check } from 'lucide-react';

const PILLARS = [
  {
    num: '01',
    title: 'LEARN VITAL TRADING SKILLS',
    desc: "School teaches you to be an employee. AlveeTrade teaches you to be the trader, investor, owner. Every lesson, signal & breakdown is built around one goal: generating income — fast.",
    bullets: [
      'World-class education in Bangla, Hindi & English',
      'Zero to consistent monthly income',
      'Forex · stocks · crypto · memecoin · fixed-time',
      'Fresh signals & breakdowns every morning',
    ],
  },
  {
    num: '02',
    title: 'JOIN A PRIVATE NETWORK',
    desc: "You are the average of the five people you spend most time with. Inside AlveeTrade: 131,000+ ambitious traders. Building. Winning. Pushing each other forward.",
    bullets: [
      'Celebrate wins with people who understand',
      'Like-minded friends on your journey',
      'Network with 131,000+ traders',
      'Business-owner Elite chat inside',
    ],
  },
  {
    num: '03',
    title: 'ACCESS TO MILLIONAIRES',
    desc: "Direct access to operators actively running the portfolios they teach. Not motivational speakers reading scripts. Real traders. Real positions. Real results.",
    bullets: [
      'Hyper-successful expert mentors',
      'Mentored every step of your journey',
      '1-on-1 advice from industry operators',
      'Elite-only live sessions & deal flow',
    ],
  },
];

export default function ThreePillars() {
  return (
    <section className="section-pad bg-[hsl(0_0%_4%)] relative">
      <div className="container-x">
        <div className="grid gap-4 sm:gap-5 md:grid-cols-3">
          {PILLARS.map((p, i) => (
            <motion.div
              key={p.num}
              initial={{ opacity: 0, y: 16 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, amount: 0.2 }}
              transition={{ duration: 0.42, delay: i * 0.05 }}
              className="relative rounded-2xl card-surface gold-hairline overflow-hidden p-5 sm:p-6 flex flex-col"
            >
              <div
                className="absolute inset-x-0 top-0 h-[2px]"
                style={{ background: 'linear-gradient(90deg, transparent, rgba(245,185,66,0.7), transparent)' }}
              />
              <div className="flex items-baseline gap-3 mb-3">
                <span className="font-display text-4xl sm:text-5xl text-[hsl(43_92%_56%)] opacity-80 leading-none">{p.num}</span>
                <span className="text-[10px] uppercase tracking-[0.22em] text-muted-foreground">Pillar</span>
              </div>
              <h3 className="font-display uppercase text-xl sm:text-2xl leading-[1.05] mb-2">{p.title}</h3>
              <p className="text-sm text-[hsl(0_0%_80%)] leading-relaxed mb-4">{p.desc}</p>
              <ul className="space-y-1.5 mt-auto">
                {p.bullets.map((b) => (
                  <li key={b} className="flex items-start gap-2 text-[13px] text-[hsl(0_0%_86%)]">
                    <span className="mt-0.5 shrink-0 h-4 w-4 rounded-full bg-[rgba(245,185,66,0.12)] text-[hsl(43_92%_56%)] flex items-center justify-center border border-[rgba(245,185,66,0.28)]">
                      <Check className="h-2.5 w-2.5" />
                    </span>
                    <span>{b}</span>
                  </li>
                ))}
              </ul>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
